import { z } from 'zod';

export const appointmentTypeSchema = z
	.object({
		enabled: z.boolean().default(false),
		calendarProvider: z.string().optional().default('none'),
		calendarId: z.string().max(200).optional().or(z.literal('')),
		defaultLength: z.coerce.number().min(5).max(240).default(30),
		notificationEmail: z.string().email('Please enter a valid email address').or(z.literal('')),
	})
	.refine((data) => !data.enabled || (data.notificationEmail && data.notificationEmail.length > 0), {
		message: 'Notification email is required when this appointment type is enabled',
		path: ['notificationEmail'],
	})
	.refine((data) => !data.calendarProvider || data.calendarProvider === 'none' || (data.calendarId && data.calendarId.length > 0), {
		message: 'Calendar ID is required when a calendar provider is selected',
		path: ['calendarId'],
	});
